// adjust.ts
import Adjust from "@adjustcom/adjust-web-sdk";

// Define the type for the config
export interface AdjustConfig {
  appToken: string;
  environement?: "production" | "sandbox";
  eventsToken: {
    purchase: string;
    purchaseRevenue: string;
    firstPurchase: string;
    firstPurchaseRevenue: string;
    loginSuccess: string;
    validatePhoneNumberPageOpening: string;
    checkoutPageOpening: string;
    shoppingCartPageOpening: string;
    addToWishlistClick: string;
    addToCartClick: string;
    registrationSuccess: string;
    searchQueryRequest: string;
    listOfItemsPageOpening: string;
    itemDetailsPageOpening: string;
    whatsAppFloatingButtonClick: string;
  };
}


// Initialize Adjust once when the app loads
export function initAdjust(configFromPartnerSettings: AdjustConfig): void {
  const config: Adjust.InitOptions  = {
    appToken: configFromPartnerSettings.appToken,
    environment: configFromPartnerSettings.environement || "sandbox"
  };
  Adjust.initSdk(config);
}

// Track a registration event
export function trackRegistration(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.registrationSuccess
      // you can add more fields here if needed
    });
  }
}


// Track a purchase event
export function trackPurchase(configFromPartnerSettings: AdjustConfig, orderId: string, amount: number, currency: string): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.purchase,
      revenue: amount,
      currency: currency
    });
  }
}

// Track a purchase Revenue event
export function trackPurchaseRevenue(configFromPartnerSettings: AdjustConfig, orderId: string, amount: number, currency: string): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.purchaseRevenue,
      revenue: amount,
      currency: currency
    });
  }
}

// Track a purchase Revenue event
export function trackLogin(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.loginSuccess
    });
  }
}

// Track a Phone Number Confirmation event
export function trackPhoneNumberConfirmation(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.validatePhoneNumberPageOpening
    });
  }
}

// Track a Checkout page event
export function trackCheckout(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.checkoutPageOpening
    });
  }
}

// Track a Shopping cart page event
export function trackShoppingCart(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.shoppingCartPageOpening
    });
  }
}

// Track a add to cart event
export function trackAddToCart(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.addToCartClick
    });
  }
}

// Track a Search query result event
export function trackSearchQueryResult(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.searchQueryRequest
    });
  }
}

// Track a List of items page event
export function trackListOfItemsPage(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.listOfItemsPageOpening
    });
  }
}

// Track a List of items page event
export function trackItemDetailsPage(configFromPartnerSettings: AdjustConfig): void {
  if(typeof configFromPartnerSettings != "undefined" && configFromPartnerSettings != null) { 
    Adjust.trackEvent({
      eventToken: configFromPartnerSettings.eventsToken.itemDetailsPageOpening
    });
  }
}